import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateUsageBundle } from "../services/update-bundle";

export function useUpdateBundleUsage() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      usage_id,
      new_bundle_id,
    }: {
      usage_id: string;
      new_bundle_id: string;
    }) => updateUsageBundle(usage_id, new_bundle_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      toast({
        title: "Success",
        description: "Bundle updated successfully",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to update bundle",
        variant: "destructive",
      });
    },
  });
}
